import styled from '@emotion/styled';

const ColumnOuterWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export default ColumnOuterWrapper;
